import { Role } from "@/models/role/role.model"
import { type IRoleServiceProvider } from "@/interfaces/api/role/role-service-provider.interface"
import { RoleTypes } from "@/enums/role-types"
import { ModelFactory } from "@/factories/model-factory"
import { Location } from "@/models/location.model"
import { RoleServiceProviderMachine } from "@/models/role-service-provider-machine.model.ts"

export class RoleServiceProvider extends Role implements IRoleServiceProvider {
  public static className = "RoleServiceProvider"
  public static verboseName = "Dienstverlener"

  roleServiceProviderMachines: RoleServiceProviderMachine[]
  location: Location

  constructor(roleServiceProvider: IRoleServiceProvider, managed = false) {
    super(roleServiceProvider)

    this.type = RoleTypes.SERVICE_PROVIDER

    this.roleServiceProviderMachines = ModelFactory.childModels(
      RoleServiceProviderMachine,
      roleServiceProvider.roleServiceProviderMachines,
      managed
    )
    this.location = ModelFactory.childModel(Location, roleServiceProvider.location, managed)
  }

  public getFirstMachine() {
    return this.roleServiceProviderMachines.length > 0
      ? this.roleServiceProviderMachines[0].machine
      : null
  }
}
